import type { ActionFunction } from '~/types/route-args';
import type { SetFeaturedArticleMutationVariables } from 'generated/graphql';
import { setFeaturedArticle } from '~/modules/directory/api/set-featured-article.server';
import { z } from 'zod';
import * as zfd from 'zod-form-data';
import { UserErrorResponse } from '~/modules/root/graphql/responses';

const SetFeaturedArticleInputSchema = z.object({
    articleID: zfd.numeric(z.number()),
    feature: z.string(),
});

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const zfdFormData = zfd.formData(SetFeaturedArticleInputSchema);
    const zfdResult = zfdFormData.safeParse(formData);
    if (!zfdResult.success) {
        throw new UserErrorResponse(zfdResult.error);
    }
    const variables: SetFeaturedArticleMutationVariables = {
        ArticleID: zfdResult.data.articleID,
        Feature: zfdResult.data.feature === 'true',
    };

    return await setFeaturedArticle({
        ...context,
        ...variables,
    });
};

export const SET_FEATURED_ARTICLE = '/remix-api/directory/set-featured-article';
